import io from 'socket.io-client';
import { WS_URL } from '../config/api';

class SocketService {
  constructor() {
    this.socket = null;
  }

  connect() {
    if (!this.socket) {
      this.socket = io(WS_URL, {
        transports: ['websocket'],
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        reconnectionAttempts: 5
      });

      this.socket.on('connect', () => {
        console.log('✅ WebSocket connected');
      });

      this.socket.on('disconnect', () => {
        console.log('🔌 WebSocket disconnected');
      });

      this.socket.on('connect_error', (error) => {
        console.error('❌ WebSocket connection error:', error);
      });
    }
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  joinMatch(matchId) {
    if (this.socket) {
      this.socket.emit('join:match', matchId);
      console.log(`👥 Joined match room: ${matchId}`);
    }
  }

  leaveMatch(matchId) {
    if (this.socket) {
      this.socket.emit('leave:match', matchId);
      console.log(`👋 Left match room: ${matchId}`);
    }
  }

  onSeatReserved(callback) {
    if (this.socket) {
      this.socket.on('seat:reserved', callback);
    }
  }

  onSeatBooked(callback) {
    if (this.socket) {
      this.socket.on('seat:booked', callback);
    }
  }

  onSeatReleased(callback) {
    if (this.socket) {
      this.socket.on('seat:released', callback);
    }
  }

  onSeatsUpdated(callback) {
    if (this.socket) {
      this.socket.on('seats:updated', callback);
    }
  }

  // Generic event listener
  on(eventName, callback) {
    if (this.socket) {
      this.socket.on(eventName, callback);
    }
  }

  // Remove specific listener
  removeListener(eventName, callback) {
    if (this.socket) {
      this.socket.off(eventName, callback);
    }
  }

  removeAllListeners() {
    if (this.socket) {
      this.socket.removeAllListeners();
    }
  }
}

export default new SocketService();


